// ============================================
// ConverseTech Frontend - Phase Progress Component
// ============================================

import type { SessionState } from '@conversetech/shared';
import { SESSION_STATES } from '@conversetech/shared';

interface PhaseProgressProps {
  currentState: SessionState;
}

/**
 * Visual progress indicator for session phases.
 *
 * Displays a horizontal bar with segments for each active phase
 * (WARMUP, DRILL, PRESSURE, FEEDBACK). Segments before the current
 * state are highlighted, showing progress through the session.
 */
export default function PhaseProgress({ currentState }: PhaseProgressProps) {
  // Get phases that should be shown in the progress bar (exclude INIT and COMPLETE)
  const visiblePhases = SESSION_STATES.filter(
    (phase) => phase !== 'INIT' && phase !== 'COMPLETE'
  );
  const currentIndex = SESSION_STATES.indexOf(currentState);

  return (
    <div className="flex gap-1">
      {visiblePhases.map((phase) => {
        const phaseIndex = SESSION_STATES.indexOf(phase);
        const isCompleted = phaseIndex < currentIndex;

        return (
          <div
            key={phase}
            className={`flex-1 h-1 rounded-full ${
              isCompleted ? 'bg-primary-500' : 'bg-gray-700'
            }`}
          />
        );
      })}
    </div>
  );
}
